
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  troughDetailModalWidth: {
    id: "TroughDetailModalWidth.width",
    defaultMessage: "Width",
  }, 
  troughDetailModalMinWidth: {
    id: "TroughDetailModalWidth.minWidth",
    defaultMessage: "Min Width",
  }, 
  troughDetailModalDepth: {
    id: "TroughDetailModalDepth.depth",
    defaultMessage: "Depth",
  },
  troughDetailModalMinDepth: {
    id: "TroughDetailModalDepth.minDepth",
    defaultMessage: "Min Depth",
  },
  troughDetailModalMinDimensions: {
    id: "TroughDetailModalDepth.minDimensions",
    defaultMessage: "min. washbasin width x depth",
  },
  troughDetailModalHeight: {
    id: "TroughDetailModalHeight.height",
    defaultMessage: "Height",
  }, 
  troughDetailModalButton: {
    id: "TroughDetailModalButton.button",
    defaultMessage: "Technical Drawing",
  }, 
});

export default MESSAGES;